import { ArrowLeft, BarChart2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from '@/clientWeb/i18n/LanguageContext'
import { EmptyState } from '../ui/empty-state'

/**
 * Attendance reports for a past meeting.
 *
 * Nothing records who attended, when they joined or left, or how often they
 * switched tabs yet, so there is nothing to report. This page used to show the
 * same five invented reports ("Q3 Sprint Retrospective" hosted by "Alex
 * Thompson"…) with fixed charts, stat cards and a "High Tab Switching Detected"
 * warning for every meeting. Build it on real data once attendance is recorded.
 */
export default function AttendanceReports() {
  const t = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      {/* Header */}
      <div className="px-4 sm:px-6 py-3 border-b border-border bg-card shrink-0">
        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-1">
          <button onClick={() => navigate('/meetings')} className="hover:text-foreground transition-colors flex items-center gap-1">
            <ArrowLeft className="w-3.5 h-3.5" /> {t('meetings.title')}
          </button>
          <span>/</span>
          <span className="text-foreground">{t('meetings.attendanceReport')}</span>
        </div>
        <h1 className="text-lg font-bold text-foreground">{t('meetings.attendanceReport')}</h1>
      </div>

      <div className="flex-1 overflow-y-auto p-4 sm:p-6">
        <EmptyState icon={BarChart2} title={t('meetings.attendanceNotRecorded')} size="md" />
      </div>
    </div>
  )
}
